import React from 'react';
import Layout from 'app/components/common/Layout';
import PagePortal from 'app/components/common/PagePortal';
import HeadInfo from 'app/components/common/HeadInfo';
import JoinFirmDirectContainer from 'app/containers/join/JoinFirmDirectContainer';

function JoinFirmSelectPage({ onClose, onSubmit }) {
	return (
		<PagePortal>
			<Layout
				usePageHook
				title="직접입력"
				usePrevBtn
				useCloseBtn
				onClose={onClose}
				contentsType="normal"
				usePc
			>
				<HeadInfo headTitle="상사선택 직접입력 | 회원가입" />

				<JoinFirmDirectContainer
					onSubmit={onSubmit}
					onClose={onClose}
				/>
			</Layout>
		</PagePortal>
	);
}

export default JoinFirmSelectPage;
